import { render } from "./Setting.vue?vue&type=template&id=2a7d545c"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=2a7d545c&lang=css"
import "./Setting.vue?vue&type=style&index=1&id=2a7d545c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__